import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { ConfigService } from './../../../../../services/infrastructure/config.service';
import { BroadcastService } from './../../../../../services/infrastructure/broadcaster.service';
import { ToastrService } from 'ngx-toastr';
import { SliderModelService } from './../../../../../services/infrastructure/sliderModel.service';
import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../../services/infrastructure/loader.service';
import { MasterConstants } from '../../../../../common/constants/master-constants';
import { CommonService } from './../../../../../services/common/common.service';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { LolLoggerService } from './../../../../../common/shared/lol-logger.service';
import { SeedReservationReconciliationService } from '../../../../../services/seed/seed-reservation-reconciliation.service';
import { Router } from '@angular/router';
import { NgbDateStruct, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { GrowerOrderService } from './../../../../../services/seed/growerOrder.service';

@Component({
  selector: 'app-grower-order-add-hybrid-product',
  templateUrl: './grower-order-add-hybrid-product.component.html',
  styleUrl: './grower-order-add-hybrid-product.component.scss'
})
export class GrowerOrderAddHybridProductComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  public productList: any;
  public selectedProductList = new Array();
  productDataSource: MatTableDataSource<any>;
  growerList: any;
  searchTypeList: string[] = ['Product Name'];
  displayedColumns: string[] = ['SeedAvailability', 'NetBEU', 'DealerBucket', 'Product Name', 'Pack Size', 'Units', 'Delivery Date', 'Product Line'];
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  filterValueList = new Array();
  isDisableSearchBtn = true;
  productFilters: any;
  selectedData: any;
  reservationUnits = 0;
  unitSelected = 0;
  dateFilter: any;
  datemodel: NgbDateStruct;
  activeCropYear: any;
  productNameSearchList: Array<any> = [];
  packageSizeList: any = [];
  packageList: any = [];
  packageSize: string;
  lastSelectedBrand: string = '';
  productNameCtrl: FormControl = new FormControl();
  filteredProductNames: Observable<string[]>;
  showProductNameAutocomplete: boolean = false;
  productNameSearchText: string = '';
  defaultSearchType: string = 'Product Name';
  isAddProductClick = false;

  constructor(
    public seedReservationReconciliationService: SeedReservationReconciliationService,
    private growerOrderService: GrowerOrderService,
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private sliderModelService: SliderModelService,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private router: Router,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar
  ) {
    this.sliderModelService.growerOrderHybridAddProductSliderValue.subscribe(x => {
      if (x) {
        this.selectedData = x;
        this.headerYear = +x.cropYear;
        this.reservationUnits = +x.reservationUnits;
      }
    });
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR)) {
      this.activeCropYear = JSON.parse(this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR));
    }
    this.resetProductFilter();
    this.bindDataSource([]);
    //this.initializeSelectedProductList();
    this.getIntialLoadData();
    this.validateDateFilter();
    this.validateDeliveryDateFilter();
    this.getHybridVarietyPackageSizeList();
    this.initProductNameAutocomplete();
  }

  //private initializeSelectedProductList(): void {
  //  const existingProducts = this.growerOrderService.getSelectedHybridProducts() || [];
  //  if (existingProducts.length > 0) {
  //    this.selectedProductList = [...existingProducts];
  //  }
  //}

  initProductNameAutocomplete(): void {
    this.filteredProductNames = this.productNameCtrl.valueChanges
      .pipe(
        debounceTime(200),
        startWith(''),
        map(val => {
          const trimmedVal = (val || '').trim();
          this.handleProductNameChange(trimmedVal);
          return trimmedVal.length >= 3 ? this.filterProductNameOptions(trimmedVal) : [];
        })
      );
  }

  private handleProductNameChange(value: string): void {
    this.productNameSearchText = value;

    if (value && value.length > 2) {
      this.showProductNameAutocomplete = true;
    } else {
      this.showProductNameAutocomplete = false;
    }

    if (value !== this.lastSelectedBrand) {
      this.clearPackageSizeSelection();
      this.updateFilterValueList();
      this.validateSearchButton();
    }
  }

  private clearPackageSizeSelection(): void {
    this.packageSizeList = [];
    this.packageSize = null;
    this.productFilters.PackageSizeList = null;
  }

  filterProductNameOptions(name: string): string[] {
    if (!name || name.length < 3) {
      return [];
    }

    const searchTerm = name.toLocaleUpperCase();

    // Get selected products from service
    const selectedProducts = this.growerOrderService.getSelectedHybridProducts() || [];
    if (!this.packageList || this.packageList.length === 0 || !this.productNameSearchList) {
      return [];
    }

    // Map productName (hybridVarietyWithMarketingBrand) -> set of available packageSizeIDs
    const availablePackagesByProduct = new Map<string, Set<string>>();
    this.packageList.forEach(pkg => {
      const productName = pkg.hybridVarietyWithMarketingBrand;
      if (!productName) { return; }
      if (!availablePackagesByProduct.has(productName)) {
        availablePackagesByProduct.set(productName, new Set<string>());
      }
      // use packageSizeID as the canonical package identifier; exclude un-packaged
      if (pkg.packageSizeID && !pkg.packageSizeID.toLowerCase().includes('up')) {
        availablePackagesByProduct.get(productName)!.add(pkg.packageSizeID);
      }
    });

    // Map productName -> set of selected packageSizeIDs (based on selectedProducts)
    const selectedPackagesByProduct = new Map<string, Set<string>>();
    selectedProducts.forEach(sel => {
      if (!sel) { return; }

      // Try to find the packageList entry for the selected product/package.
      // Selected brand is stored as hybridVarietyName (see other code). Compare using hybridVarietyName.
      const matchingPkg = this.packageList.find(p =>
        p.hybridVarietyName === sel.brand &&
        // match either by packageSizeID (preferred) or by packageSize
        ((sel.packageSizeId && p.packageSizeID === sel.packageSizeId) ||
          (!sel.packageSizeId && sel.packageSize && p.packageSize === sel.packageSize))
      );

      if (!matchingPkg) { return; }

      const prodName = matchingPkg.hybridVarietyWithMarketingBrand;
      if (!prodName) { return; }

      const set = selectedPackagesByProduct.get(prodName) ?? new Set<string>();
      if (matchingPkg.packageSizeID && !matchingPkg.packageSizeID.toLowerCase().includes('up')) {
        set.add(matchingPkg.packageSizeID);
        selectedPackagesByProduct.set(prodName, set);
      }
    });

    // Determine products where all available packages are selected
    const completelySelectedProducts = new Set<string>();
    availablePackagesByProduct.forEach((availableSet, productName) => {
      const selectedSet = selectedPackagesByProduct.get(productName);
      if (selectedSet && selectedSet.size > 0 && selectedSet.size === availableSet.size) {
        completelySelectedProducts.add(productName.toLocaleUpperCase());
      }
    });

    // Filter productNameSearchList excluding completely selected products
    const availableList = this.productNameSearchList.filter(
      a => a && !completelySelectedProducts.has(a.toLocaleUpperCase())
    );

    // First try match at start
    let list = availableList.filter(
      a => a.toLocaleUpperCase().indexOf(searchTerm) === 0
    );

    // If no results, use contains anywhere
    if (list.length === 0) {
      list = availableList.filter(
        a => a.toLocaleUpperCase().includes(searchTerm)
      );
    } else {
      // Also add items that contain the search term with a space before it
      const additionalMatches = availableList.filter(
        a => a.toLocaleUpperCase().indexOf(' ' + searchTerm) > 0
      );
      list = list.concat(additionalMatches);
    }

    return Array.from(new Set(list)); // Remove duplicates
  }
  onProductNameSelected(event: any): void {
    this.selectProductName(event.option.value);
  }

  onProductNameEnter(): void {
    const currentValue = (this.productNameCtrl.value || '').trim();
    if (currentValue && currentValue.length > 2) {
      const exactMatch = this.productNameSearchList.find(
        p => p && p.toLocaleUpperCase() === currentValue.toLocaleUpperCase()
      );
      if (exactMatch) {
        this.selectProductName(exactMatch);
      } else {
        this.clearPackageSizeSelection();
        this.updateFilterValueList();
        this.validateSearchButton();
      }
    }
  }

  private selectProductName(value: string): void {
    this.showProductNameAutocomplete = false;
    this.productNameSearchText = value;
    this.productFilters.Brand = value;
    this.lastSelectedBrand = value;

    this.packageSize = null;
    this.productFilters.PackageSizeList = null;

    // Set ProductLineId and MarketingBrandId from the selected product's data
    const matchingProduct = this.packageList.find(p => p && p.hybridVarietyWithMarketingBrand === value);
    if (matchingProduct) {
      this.productFilters.ProductLineList = [matchingProduct.productLineId];
      this.productFilters.MarketingBrandList = [matchingProduct.marketingBrandId];
      this.productFilters.Brand = matchingProduct.hybridVarietyName;
    }
    this.updatePackageSizeList(value);
    this.updateFilterValueList();
    this.validateSearchButton();
  }

  private updatePackageSizeList(productName: string): void {
    if (productName && productName.length > 2 && this.packageList && this.packageList.length > 0) {
      const filteredPackages = this.packageList
        .filter(p => p && p.hybridVarietyWithMarketingBrand === productName && p.packageSize != null && p.packageSize !== ''
          && p.packageSizeID && !p.packageSizeID.toLowerCase().includes('up'));
      console.log(this.packageList);
      // Get selected package sizes for this product from service
      const selectedProducts = this.growerOrderService.getSelectedHybridProducts();
      console.log(selectedProducts);
      // Enrich selected products with hybridVarietyWithMarketingBrand using brand from packageList
      const enrichedSelectedProducts = selectedProducts.map(selected => {
        const matchingPackage = this.packageList.find(pkg => pkg.hybridVarietyName === selected.brand);
        return {
          ...selected,
          hybridVarietyWithMarketingBrand: matchingPackage ? matchingPackage.hybridVarietyWithMarketingBrand : null
        };
      });
      console.log(enrichedSelectedProducts);
      // Get package sizes for the current product name
      const selectedPackageSizes = enrichedSelectedProducts
        .filter(p => p.hybridVarietyWithMarketingBrand === productName)
        .map(p => p.packageSize);

      const uniquePackages: { packageSize: string, packageSizeID: string }[] = [];
      filteredPackages.forEach(item => {
        if (!uniquePackages.find(x => x.packageSizeID === item.packageSizeID) &&
          !selectedPackageSizes.includes(item.packageSize)) {
          uniquePackages.push({ packageSize: item.packageSize, packageSizeID: item.packageSizeID });
        }
      });

      this.packageSizeList = uniquePackages;
      this.productFilters.PackageSizeList = null;
    } else {
      this.clearPackageSizeSelection();
    }
  }


  onPackageSizeChange(): void {
    if (this.packageSize) {
      this.productFilters.PackageSizeList = [this.packageSize];
    } else {
      this.productFilters.PackageSizeList = null;
    }
    this.updateFilterValueList();
    this.validateSearchButton();
  }

  private validateSearchButton(): void {
    const hasBrand = this.lastSelectedBrand && this.lastSelectedBrand.trim().length > 0;
    const hasPackageSize = this.packageSize && this.packageSize.length > 0;
    this.isDisableSearchBtn = !(hasBrand && hasPackageSize);
  }

  private updateFilterValueList(): void {
    this.filterValueList = this.filterValueList.filter(f =>
      !f.startsWith('Product Name :') && !f.startsWith('Package Size :'));

    if (this.lastSelectedBrand && this.lastSelectedBrand.trim().length > 0) {
      this.filterValueList.push('Product Name : ' + this.lastSelectedBrand);
    }

    if (this.packageSize) {
      const selectedPkg = this.packageSizeList.find(p => p.packageSizeID === this.packageSize);
      const displayText = selectedPkg ? selectedPkg.packageSize : this.packageSize;
      this.filterValueList.push('Package Size : ' + displayText);
    }
  }


  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);

      const calendarDate = d;
      let maxDate = new Date();
      if (this.activeCropYear) {
        maxDate = new Date(this.activeCropYear.endDate);
      }
      return calendarDate >= currentDate && calendarDate <= maxDate;
    };
  }


  onGrowerChange(grower: any) {
    if (grower) {
      this.selectedData.growerOrderId = grower.growerOrderId;
      this.selectedData.growerOrderNumber = grower.growerOrderNumber;
    } else {
      this.selectedData.growerOrderId = null;
      this.selectedData.growerOrderNumber = null;
    }
  }

  validateDeliveryDateFilter() {
    const currentDate = new Date();
    let maxDate = new Date();
    if (this.activeCropYear) {
      maxDate = new Date(this.activeCropYear.endDate);
    }
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.datemodel = this.configDate.getToday();
    this.config.maxDate = { year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate() };
  }

  syncSelectedItem(element: any) {
    const selected = this.selectedProductList.find(i => i.brandPackageSizeKey === element.brandPackageSizeKey);
    if (selected) {
      selected.desiredDeliveryDate = element.desiredDeliveryDate;
    }
    if (!element.isProductSelected && element.reservationUnits > 0 ) {
      this.keepRecords(element);
    }
  }



  geuTextChange(element: any) {
    if (
      element.reservationUnits === null ||
      element.reservationUnits === undefined ||
      (typeof element.reservationUnits === 'string' && element.reservationUnits.trim() === '') ||
      isNaN(Number(element.reservationUnits))
    ) {
      element.reservationUnits = 0;
    }

    this.updateRowData(element);
  }

  geuValueChange(action: string, productItem: any) {
    if (action == 'decrease') {
      const decValue = +productItem.reservationUnits - +productItem.conv;
      if (decValue > 0) {
        const valueBeforeDec = productItem.reservationUnits;
        productItem.reservationUnits = Math.floor(productItem.reservationUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.reservationUnits) {
          productItem.reservationUnits = (+productItem.reservationUnits > +productItem.conv ? +productItem.reservationUnits - +productItem.conv : 0);
        }
      }
      else {
        productItem.reservationUnits = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.reservationUnits;
      productItem.reservationUnits = Math.ceil(productItem.reservationUnits / +productItem.conv) * +productItem.conv;
      if (valueBeforeInc == productItem.reservationUnits) {
        productItem.reservationUnits = (+productItem.reservationUnits + +productItem.conv);
      }
    }

    this.updateRowData(productItem);
  }

  updateRowData(element: any) {
    if ((element.reservationUnits <= 0 && element.isProductSelected) ||
      (element.reservationUnits > 0 && !element.isProductSelected )) {
      this.keepRecords(element);
    } else {
      const selected = this.selectedProductList.find(i => i.brandPackageSizeKey === element.brandPackageSizeKey);
      if (selected) {
        selected.reservationUnits = +element.reservationUnits;
      }
    }

    this.calculateTotalUnitsSelected();
  }


  calculateTotalUnitsSelected() {
    const total = this.productList?.reduce((sum, item) => sum + (+item.reservationUnits || 0), 0);
    this.unitSelected = Math.round(total * 1000) / 1000;
  }



  get remainingReservationUnit(): number {
    const val = Math.max((+this.reservationUnits || 0) - (+this.unitSelected || 0), 0);
    return Math.round(val * 1000) / 1000;
  }

  getIntialLoadData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReservationReconciliationService.getProductIntialSetup(
      +this.selectedData.accountNo,
      +this.selectedData.gmk,
      this.selectedData.isParentGMK
    ).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.growerList = result
        this.growerList.forEach(grower => {
          grower.businessName = (grower.businessName == null || grower.businessName == '' ?
            (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
            (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
            (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
            : grower.businessName);
        });

        const grower = this.growerList.find(g => g.gmk === this.selectedData.gmk) ?? this.growerList[0];
        this.selectedData.growerOrderId = grower.growerOrderId;
        this.selectedData.growerOrderNumber = grower.growerOrderNumber;
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));

  }

  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1);
  }


  public bindDataSource(data: any[]) {
    this.productDataSource = new MatTableDataSource(data);
  }

  getProducts() {
    const growerGMK = +(this.selectedData?.gmk ?? this.selectedData?.growerGMK ?? 0);
    this.productFilters.ScreenName = 'grower';
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = +this.selectedData.accountNo;
    this.productFilters.GrowerGMK = growerGMK > 0 ? growerGMK : null;
    const matchedProduct = this.packageList.find(p => p && p.hybridVarietyWithMarketingBrand === this.lastSelectedBrand);
    this.productFilters.Brand = matchedProduct ? matchedProduct.hybridVarietyName : this.lastSelectedBrand;
    this.productFilters.PackageSizeList = this.packageSize ? [this.packageSize] : null;
    if (!this.validateProductFilter(this.productFilters)) {
      this.toastrService.error('Value must greater than equal to 3 characters.');
      return true;
    }
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReservationReconciliationService.getProductAvailabilityHybridVariety(this.productFilters).subscribe((result: any) => {
      let newProducts = [];
      if (result && result.status) {
        newProducts = result.resultData;
        newProducts.forEach(product => {
          product.brandPackageSizeKey = (product.brand || '') + '|' + (product.packageSize || '');
          const existing = this.selectedProductList.find(i => i.brandPackageSizeKey === product.brandPackageSizeKey);
          if (existing) {
            product.isProductSelected = true;
            product.reservationUnits = existing.reservationUnits;
            product.desiredDeliveryDate = existing.desiredDeliveryDate;
            product.isFromPreviousSearch = false;
          } else {
            product.isProductSelected = false;
            product.reservationUnits = 0;
            product.desiredDeliveryDate = null;
            product.isFromPreviousSearch = false;
          }
        });
      } else {
        if (result) {
          this.toastrService.info(result.message);
        } else {
          this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
        }
      }

      const selectedNotInResults = this.selectedProductList.filter(
        sel => !newProducts.find((p: any) => p.brandPackageSizeKey === sel.brandPackageSizeKey)
      ).map(sel => ({ ...sel, isFromPreviousSearch: true }));

      this.productList = [...selectedNotInResults, ...newProducts];

      // Reposition based on selectedProductList order
      this.repositionAllSelectedRows();

      this.bindDataSource(this.productList);
      this.loaderService.setLoaderStatus(false);
      this.calculateTotalUnitsSelected();
    }, (error) => {
      // On error, still show selected items
      this.productList = this.selectedProductList.map(item => ({ ...item, isFromPreviousSearch: true }));
      this.bindDataSource(this.productList);
      this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
      this.calculateTotalUnitsSelected();
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    }));
  }

  getHybridVarietyPackageSizeList() {
    this.subscription.push(this.growerOrderService.getHybridVarietyPackageSizeList(+this.selectedData.accountNo).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.productNameSearchList = Array.from(new Set(result.map(a => a.hybridVarietyWithMarketingBrand).filter(Boolean)));
        this.packageList = result;
      } else {
        this.productNameSearchList = [];
        this.packageList = [];
      }
    }));
  }

  repositionAllSelectedRows() {
    if (!this.productList || this.productList.length === 0) return;

    const selectedInOrder = this.selectedProductList
      .map(sel => this.productList.find(p => p.brandPackageSizeKey === sel.brandPackageSizeKey))
      .filter(p => p);

    const unselected = this.productList.filter(p => !p.isProductSelected);

    this.productList = [...selectedInOrder, ...unselected];
  }


  public getProductFilters(productFilter) {
    const growerGMK = +(this.selectedData?.gmk ?? this.selectedData?.growerGMK ?? 0);
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = +this.selectedData.accountNo;
    this.productFilters.GrowerGMK = growerGMK > 0 ? growerGMK : null;
    this.productFilters.PackageSizeList = [this.packageSize];
    return productFilter;
  }

  // to validate product filter
  public validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 3
      && productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }
    return isValid;
  }

  removeSelectedRow(item) {
    if (item.isProductSelected) {
      this.keepRecords(item);
      this.calculateTotalUnitsSelected();
    }
  }

  public keepRecords(item) {
    if (!item.isProductDeactivated) {
      const brandPackageSizeKey = item.brandPackageSizeKey;
      item.isProductSelected = !item.isProductSelected;

      if (item.isProductSelected) {
        if (!this.selectedProductList.find(i => i.brandPackageSizeKey === brandPackageSizeKey)) {
          this.selectedProductList.push({ ...item });
        }
      } else {

        this.selectedProductList = this.selectedProductList.filter(i => i.brandPackageSizeKey !== brandPackageSizeKey);
        item.reservationUnits = 0;
        item.desiredDeliveryDate = null;

        // Remove row from grid if it was from a prior search
        if (item.isFromPreviousSearch) {
          this.productList = this.productList.filter((p: any) => p.brandPackageSizeKey !== brandPackageSizeKey);
          this.bindDataSource(this.productList);
          return;
        }
      }

      // Sync with service - merge local selections with existing service state
      const existingServiceProducts = this.growerOrderService.getSelectedHybridProducts() || [];
      const mergedProducts = [...existingServiceProducts.filter(
        ep => !this.selectedProductList.find(sp => sp.brandPackageSizeKey === ep.brandPackageSizeKey)
      ), ...this.selectedProductList];
      this.growerOrderService.setSelectedHybridProducts(mergedProducts);
    }
  }




  public AddProducts() {
    if (this.selectedProductList.length === 0) {
      this.toastrService.warning('Please select at least one product.');
      return;
    }
    this.getHybridVarietyProductList();
  }

  getHybridVarietyProductList() {
    const growerGMK = +(this.selectedData?.gmk ?? this.selectedData?.growerGMK ?? 0);
    const filter = {
      AccountNumber: +this.selectedData.accountNo,
      GrowerGMK: growerGMK > 0 ? growerGMK : null,
      SelectedProductLine: this.productFilters.ProductLineList[0],
      SelectedMarketingBrand: this.productFilters.MarketingBrandList[0],
      HybridVarietyVMs: this.selectedProductList.map(p => ({
        Brand: p.brand,
        PackageSize: p.packageSizeId,
        RequestQuantity: p.reservationUnits
      }))
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReservationReconciliationService.getReconciliationHybridVarietyProductList(filter).subscribe((result: any) => {
      if (result && result.resultData && result.resultData.length > 0) {
        const selectedMap = new Map<string, any>(
          this.selectedProductList.map(p => [`${p.brand}|${p.packageSize}`, p])
        );
        result.resultData.forEach((item: any) => {
          const selected = selectedMap.get(`${item.brand}|${item.packageSize}`);
          if (selected) {
            item.desiredDeliveryDate = selected.desiredDeliveryDate;
            item.reservationUnits = item.assignedQuantity;
          }
        });
        this.selectedData.productList = result.resultData;
        // Merge current results with existing service state from prior iterations
        const existingServiceProducts = this.growerOrderService.getSelectedHybridProducts() || [];
        const mergedProducts = [...existingServiceProducts.filter(
          ep => !result.resultData.find(rp => `${rp.brand}|${rp.packageSize}` === `${ep.brand}|${ep.packageSize}`)
        ), ...result.resultData];
        this.growerOrderService.setSelectedHybridProducts(mergedProducts);
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.selectedData.productList.length });
        this.toastrService.info('Product Added');
        this.isAddProductClick = true;
        this.selectedProductList = result.resultData;
        const data = Object.assign({}, this, { source: 'GrowerOrderAddHybridProductComponent' });
        this.sliderModelService.setData<GrowerOrderAddHybridProductComponent>(data);
        this.sliderModelService.close();
        this.loaderService.setLoaderStatus(false);
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    }));
  }



  public isDefaultFilter(filterValue: string): boolean {
    return filterValue.startsWith('Marketing Brand :')
      || filterValue.startsWith('Product Line :');
  }

  getFilterData() {
    this.getProducts();
  }

  public clearAllFilter() {
    this.productNameCtrl.setValue('');
    this.productNameSearchText = '';
    this.showProductNameAutocomplete = false;
    this.lastSelectedBrand = '';
    this.packageSizeList = [];
    this.packageSize = null;

    this.selectedProductList = [];
    this.productList = new Array();
    this.isDisableSearchBtn = true;
    this.productDataSource = new MatTableDataSource([]);
    this.unitSelected = 0;

    this.filterValueList = new Array();
    this.resetProductFilter();
    this.growerOrderService.clearSelectedHybridProducts();
  }


  private clearProductNameAutocomplete(): void {
    this.productNameCtrl.setValue('');
    this.productNameSearchText = '';
    this.showProductNameAutocomplete = false;
    this.lastSelectedBrand = '';
    this.productFilters.Brand = '';
    this.clearPackageSizeSelection();
    this.updateFilterValueList();
    this.validateSearchButton();
  }



  public resetProductFilter() {
    const growerGMK = +(this.selectedData?.gmk ?? this.selectedData?.growerGMK ?? 0);
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'AccountNumber': +this.selectedData.accountNo,
      'GrowerGMK': growerGMK > 0 ? growerGMK : null,
      'Brand': null,
      'MarketingBrandList': [],
      'PackageSizeList': [],
      'ProductLineList': []
    };
    this.setDefaultFilter();
  }

  setDefaultFilter() {
    this.productFilters.MarketingBrandList = [this.selectedData.marketingBrandId];
    this.productFilters.ProductLineList = [this.selectedData.productLineId];
    if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0 && this.productFilters.ProductLineList[0] != '') {
      this.filterValueList.push('Product Line : ' + this.selectedData.productLine);
    }
    if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0 && this.productFilters.MarketingBrandList[0] != '') {
      this.filterValueList.push('Marketing Brand : ' + this.selectedData.marketingBrand);
    }
  }

  public clearFilter(filterValue: string): void {
    this.filterValueList = this.filterValueList.filter(f => f !== filterValue);

    if (filterValue.startsWith('Product Name :')) {
      this.clearProductNameAutocomplete();
    }

    if (filterValue.startsWith('Package Size :')) {
      this.packageSize = null;
      this.productFilters.PackageSizeList = null;
      this.validateSearchButton();
    }
  }


  cancelClick() {
    this.sliderModelService.close();
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
